import React from 'react'
import AccordionItem, { AccordionItemData } from './components/AccordionItem'

interface AccordionProps {
  data: AccordionItemData[]
  activeItem: number
  setActiveItem: (item: number) => void
  timeout?: number
}

const Accordion = ({ data, activeItem, setActiveItem, timeout }: AccordionProps) => {
    return (
        <div className='flex flex-col'>
            {data.map((item, index) => (
                <AccordionItem
                    key={item.id}
                    item={item}
                    activeItem={activeItem}
                    index={index}
                    setActiveItem={() => setActiveItem(index)}
                    timeout={timeout}
                    onClose={(e) => {
                        e.stopPropagation()
                        setActiveItem(index === data.length - 1 ? 0 : index + 1)
                    }}
                />
            ))}
        </div>
    )
}

export default Accordion
